import { Icon } from '@iconify/react'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import config from '../config'

const ForgotPasswordLayer = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await fetch(`${config.API_BASE_URL}/api/auth/forgot-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });

            const data = await response.json();
            if (!response.ok && response.status !== 429) throw new Error(data.error || 'Request failed');

            setSuccess(true);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <section className="auth forgot-password-page bg-base d-flex flex-wrap">
                <div className="auth-left d-lg-block d-none">
                    <div className="d-flex align-items-center flex-column h-100 justify-content-center">
                        <img src="/assets/images/auth/forgot-pass-img.png" alt="" />
                    </div>
                </div>
                <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
                    <div className="max-w-464-px mx-auto w-100 text-center">
                        <div className="mb-32">
                            <img src="/assets/images/auth/envelop-icon.png" alt="" />
                        </div>
                        <h6 className="mb-12">Verify your Email</h6>
                        <p className="text-secondary-light text-sm mb-0">
                            We have sent a password reset link to <strong>{email}</strong>. <br />
                            Please check your email for instructions.
                        </p>
                        <Link
                            to="/sign-in"
                            className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                        >
                            Back to Sign In
                        </Link>
                        <div className="mt-32 text-sm">
                            <p className="mb-0">
                                Didn't receive an email?{" "}
                                <button 
                                    onClick={handleSubmit} 
                                    disabled={loading}
                                    className="text-primary-600 fw-semibold bg-transparent border-0 p-0"
                                >
                                    Resend
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="auth forgot-password-page bg-base d-flex flex-wrap">
            <div className="auth-left d-lg-block d-none">
                <div className="d-flex align-items-center flex-column h-100 justify-content-center">
                    <img src="/assets/images/auth/forgot-pass-img.png" alt="" />
                </div>
            </div>
            <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
                <div className="max-w-464-px mx-auto w-100">
                    <div>
                        <h4 className="mb-12">Forgot Password</h4>
                        <p className="mb-32 text-secondary-light text-lg">
                            Enter the email address associated with your account and we will
                            send you a link to reset your password.
                        </p>
                    </div>
                    {error && (
                        <div className="alert alert-danger mb-3" role="alert">
                            {error}
                        </div>
                    )}
                    <form onSubmit={handleSubmit}>
                        <div className="icon-field">
                            <span className="icon top-50 translate-middle-y">
                                <Icon icon="mage:email" />
                            </span>
                            <input
                                type="email"
                                className="form-control h-56-px bg-neutral-50 radius-12"
                                placeholder="Enter Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                            disabled={loading}
                        >
                            {loading ? 'Sending...' : 'Continue'}
                        </button>
                        <div className="text-center">
                            <Link to="/sign-in" className="text-primary-600 fw-bold mt-24">
                                Back to Sign In
                            </Link>
                        </div>
                        <div className="mt-120 text-center text-sm">
                            <p className="mb-0">
                                Already have an account?{" "}
                                <Link to="/sign-in" className="text-primary-600 fw-semibold">
                                    Sign In
                                </Link>
                            </p>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    )
}

export default ForgotPasswordLayer
